import { useBoolean, useRequest } from "ahooks";
import { Input, Modal, Select, Tag,Button } from "antd";
import { ColumnsType } from "antd/lib/table";
import React, { useContext, useEffect } from "react";
import { Search } from "../search";
import { DataTable } from "../table";
import { DataTableStore, DataTableStoreProvider } from "../table/store/data_table_store";
import { ChooseCouponStore, ChooseStoreProvider } from "./store/choose_store";
import styles from "./style/index.module.scss";
import { Select as SelectAntd } from "antd";
import { chooseCouponAction } from "./action/choose_action";
import { defualtPageSize } from "../../logic/common_logic";
import { user } from "../variable";
let classId = "";

function GoodsExchange(params: IChooseGoodsExchange) {
    const { visibleModal, close, type ,id} = params;
    const { Option } = Select, 
    action = chooseCouponAction;

    const { state, dispatch } = useContext(ChooseCouponStore);
    const { state: tableState, dispatch: tableDispatch } = useContext(DataTableStore);

    const handleOk = () => {
        close && close(true, tableState.selectList);
    };

    const handleCancel = () => {

        close && close(false, null);
    };
    const cloumnsDetail: ColumnsType = [
        {
            title:'会员姓名',
            key:'1',
            align:'center',
            dataIndex:'memberName'
        },
        {
            title:'会员手机号   ',
            key:'2',
            align:'center',
            dataIndex:'phone'
           },
        {
            title:'权益方式',
            key:'3',
            align:'center',
            dataIndex:'rightsType',
            render:(v)=><>
                {v==1&&<span>新会员注册</span>}
                {v==2&&<span>充值有礼</span>}
            </>

           },
           {
            title:'发放时间',
            key:'4',
            align:'center',
            dataIndex:'giveDateTime',
           }
     ]
    let tableRowSelection: any = {};
   if(type =='radio'){
    tableRowSelection = {
        rowSelection: {
            type: "radio",
        }}
   }

    // useRequest(() => action.init({ dispatch }));
    const onSearch = async (pageIndex) => {
        await action.loadPage({ pageIndex: pageIndex, pageSize: defualtPageSize(), dispatch: tableDispatch, search: state.search ,id})
    }

    useEffect(()=>{
    })
    return (      
      

<Modal title="活动明细" visible={visibleModal}  onCancel={handleCancel} width={1000}  footer={  <Button type="primary" color="Red" onClick={handleCancel}>返回</Button>}>

<div className={styles.root}>
    {/* <Search>
      
        <Input placeholder="请输入活动名称" 
         onChange={e => action.setCondition({ dispatch, key: "seacherKey", value: e.target.value ,GoodsExchangeId})}
        />
        <input type="button" value="快速查找" 
        onClick={() => onSearch(1)} 
        />
    </Search> */}

    <div style={{ marginTop: 10}}>
        
            <DataTable columns={cloumnsDetail} action={action} {...tableRowSelection}
                onLoad={() => onSearch(1)}
                onChange={(pageIndex) => { onSearch(pageIndex) }}
                // selectColumn={true}
            />
    </div>
</div>
</Modal>
    )
}


interface IChooseGoodsExchange {
    visibleModal: boolean;
    type?:string;
    close?: (status, r) => void;
    id:string
}
export function ChooseGoodsExchange(params: IChooseGoodsExchange) {
    return (
        <ChooseStoreProvider>
            <DataTableStoreProvider>
                <GoodsExchange {...params} />
            </DataTableStoreProvider>
        </ChooseStoreProvider>
    )
}